import Page from "@/shared/page";
import { DynamicProcessesList } from "../../entities/dynamic-processes-list";
import Card from "@/shared/data-display/card";
import { RemoveDynamicProcessButton } from "../../features/remove-dynamic-process-model";
import { AddDynamicProcess } from "../../widgets/add-dynamic-process";
import { EditDynamicProcess } from "../../widgets/edit-dynamic-process/edit-dynamic-process";
import { useTranslations } from "use-intl";
import { DYNAMIC_PROCESSES_LIST_PATH } from "./dynamic-processes-list-path";
import { SaveDynamicProcessModelInModal } from "../../features/save-dynamic-process-model";

export default function DynamicProcessesListPage() {
  const t = useTranslations("DynamicProcessesListPage");

  return (
    <Page
      title={t("Dynamic processes")}
      breadcrumbsOptions={{
        path: DYNAMIC_PROCESSES_LIST_PATH,
      }}
    >
      <Page.Grid>
        <Card title={t("Dynamic processes")} extra={<AddDynamicProcess />}>
          <DynamicProcessesList
            DeleteButton={RemoveDynamicProcessButton}
            EditEntityBasedProcess={({ id, name }) => (
              <EditDynamicProcess processId={id} name={name} />
            )}
            EditDynamicProcess={SaveDynamicProcessModelInModal}
          />
        </Card>
      </Page.Grid>
    </Page>
  );
}
